export const servicePageConstants = {
	SEND_SERVICE_PAGE_REQUEST: "SEND_SERVICE_PAGE_REQUEST",
	SEND_SERVICE_PAGE_SUCCESS: "SEND_SERVICE_PAGE_SUCCESS",
	SEND_SERVICE_PAGE_ERROR: "SEND_SERVICE_PAGE_ERROR",
};